import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class ReportsParameterOffice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            office: '',
            officeList: []
        };

        this.getOfficeList = this.getOfficeList.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTextBoxChange = this.handleTextBoxChange.bind(this);
        this.getOfficeList();
    }    

    handleChange() {
        if (this.props.onChange)
            this.props.onChange(this.inputEl.value);
    }

    handleTextBoxChange(event) {
        let value = event.target.value;
        this.setState({
            office: value
        });

        if (this.props.onChange)
            this.props.onChange(value);
    }

    getOfficeList() {
        let self = this;
        ajax.api().get("get-report-parameter-offices")
            .then(function (res) {
                self.setState({ officeList: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        if (this.props.role == 'supervisor') {
            var officeListToRender = [];
            officeListToRender.push(<option key="All" value="">All</option>);
            
            this.state.officeList.map(function (item, i) {
                officeListToRender.push(<option key={item} value={item}>{item}</option>)
            }, this);

            return (      
                <div className="ap-report-control-dropdown">  
                    <FormControl
                        componentClass="select"
                        placeholder="select"
                        onChange={this.handleChange}
                        inputRef={el => this.inputEl = el}>
                        {officeListToRender}
                    </FormControl>
                </div>
            );
        }
        else {
            return (        
                <FormControl type="text" 
                    defaultValue={this.state.office}
                    onChange={this.handleTextBoxChange}>
                </FormControl>
            );
        }
    }
}